import { useState, useEffect } from "react";
import { Form, Spin, Tabs, Row, Col, Input, Button, Select, DatePicker, Checkbox } from "antd";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBalanceScale, faGift, faHandHoldingDollar, faIdCard, faIdCardAlt, faPiggyBank } from '@fortawesome/free-solid-svg-icons';

import dayjs from 'dayjs';

import { UserOutlined } from '@ant-design/icons';
import { useNavigate } from "react-router-dom";
import { apiPrimarias } from "../../../services/api";
import { brToNumber, isStateValid, pushToBase, resetColor } from "../../../utils/utilsFunctions";

import type { SimpleDropdownItem, ICtrlDoc, IDocumento, IEfpc, IEnum, IPessoaJuridica, IPlanoBeneficios, IBeneficio, ISelectList, ITipo, ITipoComponenteResgatePortabilidade, IInstituto, IAutorizacaoPlano } from "../../../components/Interfaces";

import { errorMessage, successMessage, mostrarInfo, mostrarInfoDetail } from "../../../messages/messages";
import type { IErroApi } from "../../../services/api";

import { useLocation, useParams } from "react-router";
import CadInfoBotoes from "../../../components/CadInfoBotoes";
import { carregaListaDocumento, carregaListaFundamentacaoLegal, carregaListaCaracteristica, carregaListaModalidade, carregaListaTipoRegulamento, carregaListaTipoBeneficio, carregaListaRegimeFinanceiro, carregaListaMetodoFinanciamento, carregaListaTipoExpressaoBeneficio, carregaListaPrazoPagamento, carregaListaTipoRegraCalculo, carregaListaTipoRequisitoElegibilidade, carregaListaTipoComponenteResgatePortabilidade, carregaListaTipoInstituto, carregaListaUnidadeMedidaPercentualMonetario, carregaListaUnidadeMedidaPrazo } from "../../PessoaJuridica/services";
import { maskCNPB, maskCurrency } from "../../../utils/maskFunctions";
import FormModalDocumento from "../../../components/FormModalDocumento";
import type { CheckboxProps, TabsProps } from "antd/lib";
import { PatternFormat } from "react-number-format";
import FormContribuicao from "../components/FormContribuicao";
import Beneficio from "../components/Beneficio";
import Instituto from "../components/Instituto";
import ModalEfpc from "../../Efpc/Componentes/ModalEfpc";

const Cadastrar = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { tipo } = useParams();

  const [form] = Form.useForm();
  const [planoRetPosCadastro, setPlanoRetPosCadastro] = useState<IPlanoBeneficios>();

  const [operacaoAutorizarPlano, setOperacaoAutorizarPlano] = useState<IAutorizacaoPlano>();
  const [efpcRequerente, setEfpcRequerente] = useState<IEfpc>();
  const [pessoaJuridicaPlano, setPessoaJuridicaPlano] = useState<IPessoaJuridica>();

  const [beneficios, setBeneficios] = useState<IBeneficio[]>([]);
  const [institutos, setInstitutos] = useState<IInstituto[]>([]);

  const [planoRegulamentoDocumento, setPlanoRegulamentoDocumento] = useState<IDocumento[]>([]);

  const [planoDocumentoOutros, setPlanoDocumentoOutros] = useState<IDocumento[]>([]);
  const [planoDocumentoAnalise, setPlanoDocumentoAnalise] = useState<IDocumento[]>([]);

  const [manter, _setManter] = useState(1); // 1 : Inserir / 2 : Consultar / 3 : Editar;
  const [erroApi, setErroApi] = useState<IErroApi>()

  const [listFundamentacaoLegal, setListFundamentacaoLegal] = useState<ISelectList[]>([]);
  const [listCaracteristicas, setListCaracteristicas] = useState<ISelectList[]>([]);
  const [listModalidades, setListModalidades] = useState<ISelectList[]>([]);
  const [listUnidadesMedidaContribuicaoMinima, setListUnidadesMedidaContribuicaoMinima] = useState<ISelectList[]>([]);
  const [listUnidadesMedidaCarencia, setListUnidadesMedidaCarencia] = useState<ISelectList[]>([]);

  const [listRegimeFinanceiro, setListRegimeFinanceiro] = useState<ISelectList[]>([]);
  const [listMetodoFinanciamento, setListMetodoFinanciamento] = useState<ISelectList[]>([]);
  const [listTipoExpressaoBeneficio, setListTipoExpressaoBeneficio] = useState<ISelectList[]>([]);
  const [listPrazoPagamento, setListPrazoPagamento] = useState<ISelectList[]>([]);

  const [fundamentacaoLegal, setFundamentacaoLegal] = useState(-1);
  const [caracteristica, setCaracteristica] = useState(0);
  const [modalidade, setModalidade] = useState(0);

  const [listTipoRegulamento, setListTipoRegulamento] = useState<ISelectList[]>([]);
  const [listTipoBeneficio, setListTipoBeneficio] = useState<ITipo[]>([]);

  const [listTipoInstituto, setListTipoInstituto] = useState<ITipo[]>([]);
  const [listTipoComponenteResgatePortabilidade, setListTipoComponenteResgatePortabilidade] = useState<ITipoComponenteResgatePortabilidade[]>([]);

  const [listTipoRegraCalculo, setListTipoRegraCalculo] = useState<SimpleDropdownItem[]>([]);
  const [listTipoRequisitoElegibilidade, setListTipoRequisitoElegibilidade] = useState<SimpleDropdownItem[]>([]);


  const [listDocumentoRegulamentoPlano, setListDocumentoRegulamentoPlano] = useState<ISelectList[]>([]);
  const [ctrlDocRegulamentoPlano, setCtrlDocRegulamentoPlano] = useState<ICtrlDoc[]>([]);
  const [listDocumentosOutrosPlano, setListDocumentosOutrosPlano] = useState<ISelectList[]>([]);
  const [ctrlDocsOutrosPlano, setCtrlDocsOutrosPlano] = useState<ICtrlDoc[]>([]);
  const [listDocumentosAnalise, setListDocumentosAnalise] = useState<ISelectList[]>([]);
  const [ctrlDocsAnalisePlano, setCtrlDocsAnalisePlano] = useState<ICtrlDoc[]>([]);

  const [permiteAdesaoDependente, setPermiteAdesaoDependente] = useState(false);
  const [preveInscricaoAutomatica, setPreveInscricaoAutomatica] = useState(false);

  const [tipoRegulamento, setTipoRegulamento] = useState(0);
  const [nmTipoRegulamento, setNmTipoRegulamento] = useState("");
  const [codigoModelo, setCodigoModelo] = useState("");

  const [contribuicaoNormalParticipante, setContribuicaoNormalParticipante] = useState(false);
  const [contribuicaoNormalAssistido, setContribuicaoNormalAssistido] = useState(false);
  const [contribuicaoNormalPatrocinador, setContribuicaoNormalPatrocinador] = useState(false);
  const [contribuicaoDespesaAdministrativaParticipante, setContribuicaoDespesaAdministrativaParticipante] = useState(false);
  const [contribuicaoDespesaAdministrativaAssistido, setContribuicaoDespesaAdministrativaAssistido] = useState(false);
  const [contribuicaoDespesaAdministrativaPatrocinador, setContribuicaoDespesaAdministrativaPatrocinador] = useState(false);
  const [indicadorPrevidencial, _setIndicadorPrevidencial] = useState(true);
  const [limiteMaximoSalario, setLimiteMaximoSalario] = useState(false);
  const [contribuicaoServicoPassadoParticipante, setContribuicaoServicoPassadoParticipante] = useState(false);
  const [contribuicaoServicoPassadoAssistido, setContribuicaoServicoPassadoAssistido] = useState(false);
  const [contribuicaoServicoPassadoPatrocinador, setContribuicaoServicoPassadoPatrocinador] = useState(false);
  const [preveContribuicaoMinima, setPreveContribuicaoMinima] = useState(false);
  const [contribuicaoMinima, setContribuicaoMinima] = useState("");
  const [unidadeMedidaContribuicaoMinima, setUnidadeMedidaContribuicaoMinima] = useState(0);

  const [ofereceResgateParcial, setOfereceResgateParcial] = useState(false);

  const [estadoErroApi, setEstadoErroApi] = useState(0)
  const [msgErroApi, setMsgErroApi] = useState("")

  const [sigla, setSigla] = useState("");
  const [camposValidados, setCamposValidados] = useState(false);

  const [mostrarDetalhesEfpc, setMostrarDetalhesEfpc] = useState(false)
  const [dadosEfpc, setDadosEfpc] = useState<IEfpc>()

  const [numeroProcessoEfpcFormato, setNumeroProcessoEfpcFormato] = useState("#####.######/####-##")
  const [numeroProcessoPlanoFormato, setNumeroProcessoPlanoFormato] = useState("#####.######/####-##")


  useEffect(() => {
    window.scrollTo(0, 0)

    setLoading(true);
    const carregaDadosIniciais = async () => {
      carregaListaFundamentacaoLegalOpcoes();
      carregaListaCaracteristicasOpcoes();
      carregaListaModalidadesOpcoes();
      carregaListaUnidadesMedidaPercentualMonetarioOpcoes();
      carregaListaUnidadesMedidaPrazoOpcoes();
      carregaListaTiposRegulamentosOpcoes();

      carregaListaDocumentoRegulamentoOpcoes();
      carregaListaDocumentosOutrosPlanoOpcoes();
      carregaListaDocumentosAnaliseOpcoes();

      carregaListaTiposBeneficiosOpcoes();
      carregaListaRegimeFinanceiroOpcoes();
      carregaListaMetodoFinanciamentoOpcoes();
      carregaListaTipoExpressaoBeneficioOpcoes();
      carregaListaPrazoPagamentoOpcoes();

      carregaListaTiposRegrasCalculosOpcoes();
      carregaListaTiposRequisitosElegibilidadeOpcoes();

      carregaListaTiposInstitutosOpcoes();
      carregaListaTiposComponentesResgatePortabilidadeOpcoes();
    }
    carregaDadosIniciais();
    setLoading(false);

    if (isStateValid(state)) {
      if (!tipo) {
        validarOperacaosAutorizarPlano(state.data);
        validarEfpcRequerente(state.dataEfpcRequerente);
        validarPessoaJuridicaPlano(state.dataPessoaJuridicaPlano);
        // validarDadosAuxiliaresRecebidos();
      } else {
        errorMessage("Não foi possível identificar a operação de autorização da Entidade.");
        pushToBase(navigate);
      }
    }

  }, []);

  useEffect(() => {
    if (mostrarDetalhesEfpc && !dadosEfpc) {
      setDadosEfpc(efpcRequerente);
    }
  }, [mostrarDetalhesEfpc]);

  useEffect(() => {
    if (planoRetPosCadastro) pushToManter(planoRetPosCadastro);
  }, [planoRetPosCadastro]);

  useEffect(() => {
    if (tipoRegulamento) {
      let localNmRegulamento = listTipoRegulamento.find(f => f.value === tipoRegulamento)?.label;
      if (localNmRegulamento && localNmRegulamento !== "")
        setNmTipoRegulamento(localNmRegulamento);
    }
  }, [tipoRegulamento]);

  useEffect(() => {
    if (camposValidados) {
      sendForm();
      setCamposValidados(false);
    }
  }, [camposValidados]);

  useEffect(() => {
    if (!preveContribuicaoMinima) {
      form.setFieldsValue({
        contribuicaoMinima: undefined,
        nmUnidadeMedidaContribuicaoMinima: undefined,
      });
      setContribuicaoMinima("");
      setUnidadeMedidaContribuicaoMinima(0);
    }
  }, [preveContribuicaoMinima]);

  useEffect(() => {
    if (operacaoAutorizarPlano) {
      form.setFieldsValue({
        operacaoDtPosicao: operacaoAutorizarPlano.dataPosicao ? dayjs(operacaoAutorizarPlano.dataPosicao) : undefined,
        operacaoNumero: operacaoAutorizarPlano.numero,
      });
    }
    if (efpcRequerente) {
      if (efpcRequerente?.pessoaJuridicaEfpc?.numeroProcesso?.length !== 15)
        setNumeroProcessoEfpcFormato("####################");

      form.setFieldsValue({
        efpcNumeroEfpcCnpj: efpcRequerente.pessoaJuridicaEfpc?.numero,
        efpcNumeroProcesso: efpcRequerente.pessoaJuridicaEfpc?.numeroProcesso,
        efpcRazaoSocial: efpcRequerente.pessoaJuridicaEfpc?.razaoSocial,
      });
    }
    if (pessoaJuridicaPlano) {
      if (pessoaJuridicaPlano?.numeroProcesso?.length !== 15)
        setNumeroProcessoPlanoFormato("####################");
      form.setFieldsValue({
        numeroProcesso: pessoaJuridicaPlano.numeroProcesso,
        nome: pessoaJuridicaPlano.razaoSocial,
      });
    }
  }, [operacaoAutorizarPlano, efpcRequerente, pessoaJuridicaPlano]);

  function validarOperacaosAutorizarPlano(opAutorizacaoPlano: IAutorizacaoPlano) {
    if (!opAutorizacaoPlano || !opAutorizacaoPlano.serieEfpc || opAutorizacaoPlano.serieEfpc <= 0) {
      errorMessage("A Operação de Autorização de Plano não foi identificada.");
      pushToBase(navigate);
    } else {
      setOperacaoAutorizarPlano(opAutorizacaoPlano);
    }
  }

  function validarEfpcRequerente(efpcReq: IEfpc) {
    if (!efpcReq || !efpcReq.serie || efpcReq.serie <= 0) {
      errorMessage("Entidade Requerente não identificada");
      pushToBase(navigate);
    } else {
      setEfpcRequerente(efpcReq);
    }
  }

  function validarPessoaJuridicaPlano(pjPlano: IPessoaJuridica) {
    if (pjPlano && pjPlano.serie && pjPlano.serie > 0) {
      setPessoaJuridicaPlano(pjPlano);
    }
  }

  function pushToManter(efpc: IPlanoBeneficios) {  // ABRE A TELA DE DETALHES DO DIRETOR
    let tpSelecao = {
      manter: 2,
      data: efpc
    }
    navigate("/" + import.meta.env.VITE_APP_BASE + "/plano-manter", { state: tpSelecao });
  }

  useEffect(() => {
    if (erroApi) {
      if (estadoErroApi === 400) {
        mostrarInfoDetail("Erro de Requisição", erroApi);
      } else if (estadoErroApi === 401) {
        mostrarInfo("Erro de Acesso", "Não autorizado. Tente fazer o login novamente. Mensagem do servidor: " + msgErroApi);
      } else if (estadoErroApi === 403) {
        mostrarInfo("Erro de Acesso", "O acesso ao recurso é proibido. Mensagem do servidor: " + msgErroApi);
      } else {
        mostrarInfo("Erro de comunicação", "Verifique na opção consulta se o cadastro foi efetivado. Mensagem do servidor: " + msgErroApi);
      }
      setErroApi(undefined);
      setEstadoErroApi(0);
      setMsgErroApi("");

    }
  }, [erroApi])

  // Flag para disparar o Carregamento da Pagina
  const [loading, setLoading] = useState(false);
  const [tipLoading, setTipLoading] = useState("");

  const validarPlanoBeneficio = () => {
    if (!efpcRequerente || efpcRequerente.numero === "") {
      errorMessage("Pessoa Jurídica do requerente não identificada.");
      return;
    }

    if (!institutos || institutos.length < 4) {
      errorMessage("Institutos inválidos. Deveriam constar ao menos 4.");
      return;
    }

    if (!institutos || (ofereceResgateParcial && institutos.length < 5)) {
      errorMessage("Institutos inválidos. Deveriam constar ao menos 5.");
      return;
    }

    let tipoInstitutoResgate: ITipo | undefined = listTipoInstituto.find((i) => i.nome === "RESGATE");

    let institutoResgateIntegral: IInstituto | undefined = institutos.find((i) => i.tipoInstitutoId === tipoInstitutoResgate?.id && !i.resgateParcial);

    if (!institutoResgateIntegral) {
      errorMessage("Institutos de resgate não localizado.");
      return;
    }

    if (caracteristica === 2) {
      if (!institutoResgateIntegral.carencia || institutoResgateIntegral.carencia === 0) {
        errorMessage("Carência obrigatória para plano instituidor.");
        return;
      }

      // carência em dias.
      if ((!institutoResgateIntegral.carencia || institutoResgateIntegral.carencia < 1080) && institutoResgateIntegral.unidadeMedidaCarencia == 1) {
        errorMessage("Carência mínima obrigatória para plano instituidor.");
        return;
      }

      // carência em meses.
      if ((!institutoResgateIntegral.carencia || institutoResgateIntegral.carencia < 36) && institutoResgateIntegral.unidadeMedidaCarencia == 3) {
        errorMessage("Carência mínima obrigatória para plano instituidor.");
        return;
      }

      // carência em anos.
      if ((!institutoResgateIntegral.carencia || institutoResgateIntegral.carencia < 3) && institutoResgateIntegral.unidadeMedidaCarencia == 5) {
        errorMessage("Carência mínima obrigatória para plano instituidor.");
        return;
      }
    }

    form
      .validateFields()
      .then(() => {
        setCamposValidados(true);
      })
      .catch((_error) => {
        errorMessage("Campo obrigatório não preechido");
      });

  };

  const sendForm = async () => {
    const currentForm = form.getFieldsValue();

    setTipLoading("Salvando dados ...");
    setLoading(true);

    const jsonPlano: IPlanoBeneficios =
    {
      numero: "",
      serie: -1,

      nome: currentForm.nome.toUpperCase(),
      sigla: sigla.toUpperCase(),
      caracteristica: caracteristica,
      modalidade: modalidade,
      fundamentacaoLegal: fundamentacaoLegal,
      tipoRegulamento: tipoRegulamento,
      codigoModelo: codigoModelo.toUpperCase(),
      contribuicaoMinima: brToNumber(contribuicaoMinima),
      unidadeMedidaContribuicaoMinima: unidadeMedidaContribuicaoMinima,
      permiteAdesaoDependente: permiteAdesaoDependente,
      indicadorPrevidencial: indicadorPrevidencial,
      preveInscricaoAutomatica: preveInscricaoAutomatica,
      limiteMaximoSalario: limiteMaximoSalario,
      preveContribuicaoMinima: preveContribuicaoMinima,

      contribuicaoNormalAssistido: contribuicaoNormalAssistido,
      contribuicaoNormalParticipante: contribuicaoNormalParticipante,
      contribuicaoNormalPatrocinador: contribuicaoNormalPatrocinador,

      contribuicaoDespesaAdministrativaAssistido: contribuicaoDespesaAdministrativaAssistido,
      contribuicaoDespesaAdministrativaParticipante: contribuicaoDespesaAdministrativaParticipante,
      contribuicaoDespesaAdministrativaPatrocinador: contribuicaoDespesaAdministrativaPatrocinador,

      contribuicaoServicoPassadoAssistido: contribuicaoServicoPassadoAssistido,
      contribuicaoServicoPassadoParticipante: contribuicaoServicoPassadoParticipante,
      contribuicaoServicoPassadoPatrocinador: contribuicaoServicoPassadoPatrocinador,

      ofereceResgateParcial: ofereceResgateParcial || false,

      numeroEfpc: efpcRequerente?.numero || "",
      numeroPessoaJuridica: pessoaJuridicaPlano?.numero || "",

      dataVigencia: currentForm.dataAutorizacao ? dayjs(currentForm.dataAutorizacao).format("YYYY-MM-DD") : "",

      beneficios: beneficios.map((e: IBeneficio) => {
        return {
          ...e
        };
      }),
      institutos: institutos.map((e: IInstituto) => {
        return {
          ...e
        };
      }),
      documentos: [
        ...(planoRegulamentoDocumento ?? []),
        ...(planoDocumentoOutros ?? []),
        ...(planoDocumentoAnalise ?? [])
      ].map((e: IDocumento) => ({ ...e })),

    }

    try {
      let query = `/plano-de-beneficios/autorizacao/aprovar/${operacaoAutorizarPlano?.numero}`;

      await apiPrimarias.post(query, jsonPlano).then((response) => {
        //console.log(response);
        successMessage(
          `Plano de Benefício ${response.data.sigla} (${maskCNPB(response.data.numero)}) cadastrado com Sucesso`
        );
        setPlanoRetPosCadastro(response.data);
      })

    } catch (error: any) {
      let data: IErroApi = error.response.data;
      let msgErro = data.mensagem ? data.mensagem : error.response.data.message;
      let msgDetalheErro = data.campos ? ". " + data.campos[0].cmensagem : "";
      setEstadoErroApi(error.response.status);
      setMsgErroApi(msgErro + msgDetalheErro);
      if (error.response.status < 500) {
        setErroApi(data);
      } else {
        if (error.response.status === 503)
          errorMessage("Servidor remoto não disponível");
        else
          errorMessage(msgErro);
      }
    } finally {
      setLoading(false);
    }

  };

  const onFinishFailed = () => {
    errorMessage("Campo obrigatório não preechido");
  };

  const resetForm = () => {
    setLoading(true);
    form.getFieldsValue();
    form.setFieldsValue({
      idEfpc: undefined,
      idPessoaJuridica: undefined,
      dtInicioAtuacao: undefined,
      dtFimAtuacao: undefined,
      campoServidorPublico: undefined,
      nuCnpj: undefined,
      razaoSocial: undefined,
      matriculaSiape: undefined,
      nmCargoOrigem: undefined,
    });
    setLoading(false);
    window.scrollTo(0, 0)
  };

  const carregaListaTiposBeneficiosOpcoes = async () => {
    // let listaLocal: any = [];
    await carregaListaTipoBeneficio().then((response) => {
      // response.data.forEach((p: ITipo) => {
      //   listaLocal.push({ value: p.id, label: p.nome });
      // });
      setListTipoBeneficio(response.data);
    });
  }

  const carregaListaTiposRegrasCalculosOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaTipoRegraCalculo().then((response) => {
      response.data.forEach((p: ITipo) => {
        listaLocal.push({ key: p.id, label: p.nome });
      });
      setListTipoRegraCalculo(listaLocal);
    });
  }

  const carregaListaTiposRequisitosElegibilidadeOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaTipoRequisitoElegibilidade().then((response) => {
      response.data.forEach((p: ITipo) => {
        listaLocal.push({ key: p.id, label: p.nome });
      });
      setListTipoRequisitoElegibilidade(listaLocal);
    });
  }

  const carregaListaTiposInstitutosOpcoes = async () => {
    //    let listaLocal: any = [];
    await carregaListaTipoInstituto().then((response) => {
      // response.data.forEach((p: ITipo) => {
      //   listaLocal.push({ id: p.id, label: p.nome });
      // });
      setListTipoInstituto(response.data);
    });
  }

  const carregaListaTiposComponentesResgatePortabilidadeOpcoes = async () => {
    //    let listaLocal: any = [];
    await carregaListaTipoComponenteResgatePortabilidade().then((response) => {
      // response.data.forEach((p: ITipoComponenteResgatePortabilidade) => {
      //   listaLocal.push({ key: p.id, label: p.nome, resgateIntegral: p.resgateIntegral, resgateParcial: p.resgateParcial, portabilidade: p.portabilidade, planoPatrocinado: p.planoPatrocinado, planoInstituido: p.planoInstituido });
      // });
      setListTipoComponenteResgatePortabilidade(response.data);
    });
  }

  const carregaListaTiposRegulamentosOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaTipoRegulamento().then((response) => {
      response.data.forEach((p: IEnum) => {
        listaLocal.push({ value: p.codigo, label: p.descricao });
      });
      setListTipoRegulamento(listaLocal);
    });
  }

  const carregaListaDocumentoRegulamentoOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaDocumento("1126999422668802").then((response) => {
      if (response.data.length === 0) {
        errorMessage("Não foi possível recuperar o tipo de documento do regulamento");
      } else {
        setCtrlDocRegulamentoPlano(response.data);
        response.data.forEach((p: ICtrlDoc) => {
          listaLocal.push({ value: p.idCtrlDocTpDoc, label: p.nmTpDoc });
        });
      }
    });
    setListDocumentoRegulamentoPlano(listaLocal);
  }


  const carregaListaDocumentosOutrosPlanoOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaDocumento("2252899329528834").then((response) => {
      setCtrlDocsOutrosPlano(response.data);
      response.data.forEach((p: ICtrlDoc) => {
        listaLocal.push({ value: p.idCtrlDocTpDoc, label: p.nmTpDoc });
      });
    });
    setListDocumentosOutrosPlano(listaLocal);
  }

  const carregaListaDocumentosAnaliseOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaDocumento("4504699143222273").then((response) => {
      setCtrlDocsAnalisePlano(response.data);
      response.data.forEach((p: ICtrlDoc) => {
        listaLocal.push({ value: p.idCtrlDocTpDoc, label: p.nmTpDoc });
      });
    });
    setListDocumentosAnalise(listaLocal);
  }


  const carregaListaFundamentacaoLegalOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaFundamentacaoLegal().then((response) => {
      response.data.forEach((p: IEnum) => {
        listaLocal.push({ value: p.codigo, label: p.descricao });
      });
    });
    setListFundamentacaoLegal(listaLocal);
  }

  const carregaListaCaracteristicasOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaCaracteristica().then((response) => {
      response.data.forEach((p: IEnum) => {
        listaLocal.push({ value: p.codigo, label: p.descricao });
      });
    });
    setListCaracteristicas(listaLocal);
  }

  const carregaListaModalidadesOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaModalidade().then((response) => {
      response.data.forEach((p: IEnum) => {
        listaLocal.push({ value: p.codigo, label: p.descricao });
      });
    });
    setListModalidades(listaLocal);
  }

  const carregaListaUnidadesMedidaPercentualMonetarioOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaUnidadeMedidaPercentualMonetario().then((response) => {
      response.data.forEach((p: IEnum) => {
        listaLocal.push({ value: p.codigo, label: p.descricao });
      });
    });
    setListUnidadesMedidaContribuicaoMinima(listaLocal);
  }

  const carregaListaUnidadesMedidaPrazoOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaUnidadeMedidaPrazo().then((response) => {
      response.data.forEach((p: IEnum) => {
        listaLocal.push({ value: p.codigo, label: p.descricao });
      });
    });
    setListUnidadesMedidaCarencia(listaLocal);
  }


  const carregaListaRegimeFinanceiroOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaRegimeFinanceiro().then((response) => {
      response.data.forEach((p: IEnum) => {
        listaLocal.push({ value: p.codigo, label: p.descricao });
      });
    });
    setListRegimeFinanceiro(listaLocal);
  }

  const carregaListaMetodoFinanciamentoOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaMetodoFinanciamento().then((response) => {
      response.data.forEach((p: IEnum) => {
        listaLocal.push({ value: p.codigo, label: p.descricao });
      });
    });
    setListMetodoFinanciamento(listaLocal);
  }

  const carregaListaTipoExpressaoBeneficioOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaTipoExpressaoBeneficio().then((response) => {
      response.data.forEach((p: IEnum) => {
        listaLocal.push({ value: p.codigo, label: p.descricao });
      });
    });
    setListTipoExpressaoBeneficio(listaLocal);
  }

  const carregaListaPrazoPagamentoOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaPrazoPagamento().then((response) => {
      response.data.forEach((p: IEnum) => {
        listaLocal.push({ value: p.codigo, label: p.descricao });
      });
    });
    setListPrazoPagamento(listaLocal);
  }

  const handlerTipoRegulamento = (tpReg: any) => {
    setTipoRegulamento(tpReg.value);
    setNmTipoRegulamento(tpReg.label);
    form.setFieldsValue({
      "nmTpRegulamento": tpReg.label.toUpperCase(),
    })

    form.resetFields([
      "codigoModelo",
    ]);
  };

  const handleFundamentacaoLegal = async (fundamentacaoLegal: any) => {
    form.setFieldsValue({
      nmFundamentacaoLegal: fundamentacaoLegal.label,
    });
    setFundamentacaoLegal(fundamentacaoLegal.value);
  };

  const handleCaracteristica = async (caracteristica: any) => {
    form.setFieldsValue({
      nmCaracteristica: caracteristica.label,
    });
    setCaracteristica(caracteristica.value);
  };

  const handleModalidade = async (modalidade: any) => {
    form.setFieldsValue({
      nmModalidade: modalidade.label,
    });
    setModalidade(modalidade.value);
  };

  const handleUnidadeMedidaContribuicaoMinima = async (undMed: any) => {
    form.setFieldsValue({
      nmUnidadeMedidaContribuicaoMinima: undMed.label,
    });
    setUnidadeMedidaContribuicaoMinima(undMed.value);
  };

  const onChangeAdesaoDependentes: CheckboxProps['onChange'] = (e) => {
    setPermiteAdesaoDependente(e.target.checked);
  };

  const onChangeInscricaoAutomatica: CheckboxProps['onChange'] = (e) => {
    setPreveInscricaoAutomatica(e.target.checked);
  };

  const onChangeSalarioMaximo: CheckboxProps['onChange'] = (e) => {
    setLimiteMaximoSalario(e.target.checked);
  };

  const onChangeContribuicaoMinima: CheckboxProps['onChange'] = (e) => {
    setPreveContribuicaoMinima(e.target.checked);
  };

  const onChangeResgateParcial: CheckboxProps['onChange'] = (e) => {
    setOfereceResgateParcial(e.target.checked);
  };

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: 'Regulamento',
      icon: <FontAwesomeIcon icon={faBalanceScale} />,
      children:
        <>
          <Form layout='vertical' style={{ padding: 24 }} scrollToFirstError form={form} >
            <Row>
              <Col xs={24} sm={8}>
                <Form.Item label="Tipo de Regulamento"
                  labelAlign="left"
                  labelCol={{ span: 20 }}
                  name="nmTpRegulamento"
                  colon={false}
                  rules={[
                    {
                      required: manter !== 2 ? true : false,
                      message: "Selecione o Tipo de Regulamento",
                    },
                  ]}
                >
                  <Select
                    disabled={manter === 2 ? true : false}
                    placeholder="Tipo de Regulamento"
                    showSearch
                    filterOption
                    optionFilterProp='children'
                    options={listTipoRegulamento}
                    onChange={(_, index) => {
                      handlerTipoRegulamento(index);
                    }}
                  />

                </Form.Item>
              </Col>

              <Col xs={24} sm={6}>
                <Form.Item label="Código do Modelo"
                  name="codigoModelo"
                  colon={false}
                  rules={[
                    {
                      required: manter !== 2 ? nmTipoRegulamento.includes("MODELO") ? true : false : false,
                      message: "Preencha o Código do Modelo",
                    },
                  ]}
                >
                  <Input
                    disabled={manter === 2 ? true : !nmTipoRegulamento.includes("MODELO") ? true : false}
                    onBlur={(e) => {
                      setCodigoModelo(e.target.value);
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <FormModalDocumento
            ctrlDoc={ctrlDocRegulamentoPlano}
            objetoDocumento={planoRegulamentoDocumento}
            setObjetoDocumento={setPlanoRegulamentoDocumento}
            listaDocumentos={listDocumentoRegulamentoPlano}
            manter={manter}
          />
        </>
    },
    {
      key: '2',
      label: 'Contribuições',
      icon: <FontAwesomeIcon icon={faPiggyBank} />,
      children:
        <>
          <Form layout='vertical' style={{ padding: 24 }} scrollToFirstError form={form} >
            <Row>
              <Col xs={24} md={12} xl={10}>
                <Checkbox onChange={onChangeSalarioMaximo}>Existe Limite Máximo de Salário de Contribuição/Participação</Checkbox>
              </Col>

              <Col xs={24} md={12} xl={6}>
                <Checkbox onChange={onChangeContribuicaoMinima}>Prevê Contribuição Mínima</Checkbox>
              </Col>

              <Col xs={24} xl={4}>
                <Form.Item
                  label="Contribuição Mínima"
                  name="contribuicaoMinima"
                  rules={[
                    {
                      required: preveContribuicaoMinima,
                      message: "Preencha a Contribuição Mínima",
                    },
                  ]}                >
                  <Input
                    disabled={!preveContribuicaoMinima}
                    onChange={(e) =>
                      form.setFieldsValue({
                        contribuicaoMinima: maskCurrency(e.target.value),
                      })
                    }
                    onBlur={(e) => {
                      setContribuicaoMinima(maskCurrency(e.target.value));
                    }}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} md={12} xl={4}>
                <Form.Item
                  label="Unidade de Medida"
                  name="nmUnidadeMedidaContribuicaoMinima"
                  rules={[
                    {
                      required: preveContribuicaoMinima,
                      message: "Selecione a Unidade de Medida",
                    },
                  ]}
                >
                  <Select
                    disabled={!preveContribuicaoMinima}
                    showSearch filterOption optionFilterProp='children'
                    placeholder="Unidade de Medida"
                    options={listUnidadesMedidaContribuicaoMinima}
                    onChange={(_, index) => {
                      handleUnidadeMedidaContribuicaoMinima(index);
                    }}
                  />
                </Form.Item>
              </Col>

            </Row>
          </Form>

          <FormContribuicao
            initialState={{
              "Contribuição Normal-Participante": contribuicaoNormalParticipante,
              "Contribuição Normal-Assistido": contribuicaoNormalAssistido,
              "Contribuição Normal-Patrocinador": contribuicaoNormalPatrocinador,

              "Contribuição p/ Despesas Administrativas-Participante": contribuicaoDespesaAdministrativaParticipante,
              "Contribuição p/ Despesas Administrativas-Assistido": contribuicaoDespesaAdministrativaAssistido,
              "Contribuição p/ Despesas Administrativas-Patrocinador": contribuicaoDespesaAdministrativaPatrocinador,

              "Contribuição p/ Serviço Passado-Participante": contribuicaoServicoPassadoParticipante,
              "Contribuição p/ Serviço Passado-Assistido": contribuicaoServicoPassadoAssistido,
              "Contribuição p/ Serviço Passado-Patrocinador": contribuicaoServicoPassadoPatrocinador,
            }}

            setContribuicaoNormalParticipante={setContribuicaoNormalParticipante}
            setContribuicaoNormalAssistido={setContribuicaoNormalAssistido}
            setContribuicaoNormalPatrocinador={setContribuicaoNormalPatrocinador}

            setContribuicaoPDespesasAdministrativasParticipante={setContribuicaoDespesaAdministrativaParticipante}
            setContribuicaoPDespesasAdministrativasAssistido={setContribuicaoDespesaAdministrativaAssistido}
            setContribuicaoPDespesasAdministrativasPatrocinador={setContribuicaoDespesaAdministrativaPatrocinador}

            setContribuicaoPServicoPassadoParticipante={setContribuicaoServicoPassadoParticipante}
            setContribuicaoPServicoPassadoAssistido={setContribuicaoServicoPassadoAssistido}
            setContribuicaoPServicoPassadoPatrocinador={setContribuicaoServicoPassadoPatrocinador} />
        </>
    },
    {
      key: '3',
      label: 'Benefícios',
      icon: <FontAwesomeIcon icon={faGift} />,
      children:
        <Beneficio
          form={form}
          objetoBeneficio={beneficios}
          setObjetoBeneficio={setBeneficios}
          listTiposBeneficios={listTipoBeneficio}
          listRegimeFinanceiro={listRegimeFinanceiro}
          listMetodoFinanciamento={listMetodoFinanciamento}
          listTipoExpressaoBeneficio={listTipoExpressaoBeneficio}
          listPrazoPagamento={listPrazoPagamento}
          listTipoRegraCalculo={listTipoRegraCalculo}
          listTipoRequisitoElegibilidade={listTipoRequisitoElegibilidade}
          manter={manter}
        />
    },
    {
      key: '4',
      label: 'Institutos',
      icon: <FontAwesomeIcon icon={faHandHoldingDollar} />,
      children:
        <>
          <Form layout='vertical' style={{ padding: 24 }} scrollToFirstError form={form}>
            <Row>
              <Col xs={24} md={12} xl={10}>
                <Checkbox onChange={onChangeResgateParcial}>Plano oferece resgate parcial</Checkbox>
              </Col>
            </Row>
          </Form>

          <Instituto
            form={form}
            institutos={institutos}
            setInstitutos={setInstitutos}
            caracteristica={caracteristica}
            resgateParcial={ofereceResgateParcial}
            listTiposInstitutos={listTipoInstituto}
            listTiposComponentes={listTipoComponenteResgatePortabilidade}
            listUnidadesMedida={listUnidadesMedidaCarencia}
            manter={manter} />
        </>
    },
    {
      key: '5',
      label: 'Outros Documentos do Plano',
      icon: <FontAwesomeIcon icon={faIdCard} />,
      children:
        <FormModalDocumento
          ctrlDoc={ctrlDocsOutrosPlano}
          objetoDocumento={planoDocumentoOutros}
          setObjetoDocumento={setPlanoDocumentoOutros}
          listaDocumentos={listDocumentosOutrosPlano}
          manter={manter}
        />
    },
    {
      key: '6',
      label: 'Documentação de Análise/Autorização',
      icon: <FontAwesomeIcon icon={faIdCardAlt} />,
      children:
        <FormModalDocumento
          ctrlDoc={ctrlDocsAnalisePlano}
          objetoDocumento={planoDocumentoAnalise}
          setObjetoDocumento={setPlanoDocumentoAnalise}
          listaDocumentos={listDocumentosAnalise}
          manter={manter}
        />
    },
  ];


  return (
    <>
      {/* <Prompt
        when={idEfpc !== undefined && idEfpc !== 0}
        message="Tem certeza de que deseja sair da página? Podem existir dados não salvos."
      /> */}

      <Spin spinning={loading} tip={tipLoading}>

        <Form layout='vertical' style={{ padding: 24 }} scrollToFirstError form={form} >

          <div className="main-content pl-sm-3 mt-4">
            <h1>Cadastrar Plano de Benefício</h1>
          </div>

          <div className="main-content pl-sm-3 mt-4">
            <h2>Operação / Entidade Requerente</h2>
          </div>

          <Row>
            <Col xs={24} xl={2}>
              <Form.Item label="Número"
                name="operacaoNumero">
                <Input disabled={true} />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={5}>
              <Form.Item
                label="Data da Posicao"
                name="operacaoDtPosicao">
                <DatePicker
                  format={"DD/MM/YYYY"}
                  style={{ width: "100%" }}
                  disabled={true}
                />
              </Form.Item>
            </Col>
          </Row>

          {/* <Row>
            <Col xs={24} xl={12}>
              <Form.Item label="Justificativa"
                name="operacaoJustificativa">
                <Input disabled={true} />
              </Form.Item>
            </Col>
          </Row> */}

          <Row>
            <Col xs={24} xl={5}>
              <Form.Item
                label="CNPJ"
                name="efpcNumeroEfpcCnpj">
                <PatternFormat
                  disabled
                  customInput={Input}
                  format="##.###.###/####-##"
                />
              </Form.Item>
            </Col>

            <Col xs={24} xl={5}>
              <Form.Item
                label="Número do processo"
                name="efpcNumeroProcesso">
                <PatternFormat
                  customInput={Input}
                  format={numeroProcessoEfpcFormato}
                  disabled
                />
              </Form.Item>
            </Col>

            <Col xs={24} xl={10}>
              <Form.Item label="Razão Social"
                name="efpcRazaoSocial">
                <Input disabled={true} />
              </Form.Item>
            </Col>

            <Col xs={24} xl={4} >
              <Form.Item style={{ alignItems: 'center' }}
                label={"Detalhar Cadastro da Entidade"}
              >
                <Button
                  shape='round'
                  onClick={() => {
                    setMostrarDetalhesEfpc(!mostrarDetalhesEfpc);
                  }}
                  type='primary'
                  icon={<UserOutlined />}
                />
              </Form.Item>
            </Col>
          </Row>

          <ModalEfpc
            dadosEfpc={dadosEfpc}
            modalEfpcSucessoAberto={mostrarDetalhesEfpc}
            setModalEfpcSucessoAberto={setMostrarDetalhesEfpc}
          />

          <div className="main-content pl-sm-3 mt-4">
            <h2>Perfil do Plano de Benefícios</h2>
          </div>

          <Row>

            <Col xs={24} xl={6}>
              <Form.Item
                label="Número do processo"
                name="numeroProcesso">
                <PatternFormat
                  customInput={Input}
                  format={numeroProcessoPlanoFormato}
                  disabled
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={5}>
              <Form.Item
                label="Data da Autorizacao"
                name="dataAutorizacao"
                rules={[
                  {
                    required: true,
                    message: "Data da Autorização não preenchida",
                  },
                ]}
              >
                <DatePicker
                  format={"DD/MM/YYYY"}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={13}>
              <Form.Item
                label="Nome"
                name="nome"
                rules={[
                  {
                    required: true,
                    message: "Preencha o Nome do Plano",
                  },
                ]}
              >
                <Input disabled />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col xs={24} md={12} xl={6}>
              <Form.Item
                label="Sigla"
                name="sigla"
                rules={[
                  {
                    required: true,
                    message: "Preencha a Sigla do Plano",
                  },
                ]}
              >
                <Input
                  onBlur={(e) => {
                    setSigla(e.target.value);
                  }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={8}>
              <Form.Item
                label="Característica"
                name="nmcaracteristica"
                rules={[
                  {
                    required: true,
                    message: "Selecione uma Característica",
                  },
                ]}
              >
                <Select
                  showSearch filterOption optionFilterProp='children'
                  placeholder="Característica"
                  options={listCaracteristicas}
                  onChange={(_, index) => {
                    handleCaracteristica(index);
                  }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={10}>
              <Checkbox onChange={onChangeAdesaoDependentes}>Permite Adesão de Dependentes</Checkbox>
            </Col>

          </Row>

          <Row>
            <Col xs={24} md={12} xl={6}>
              <Form.Item
                label="Modalidade"
                name="nmModalidade"
                rules={[
                  {
                    required: true,
                    message: "Selecione a Modalidade do Plano",
                  },
                ]}
              >
                <Select
                  showSearch filterOption optionFilterProp='children'
                  placeholder="Modalidade"
                  options={listModalidades}
                  onChange={(_, index) => {
                    handleModalidade(index);
                  }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={8}>
              <Form.Item
                label="Fundamentação Legal"
                name="nmFundamentacaoLegal"
                rules={[
                  {
                    required: true,
                    message: "Fundamentação Legal obrigatório não preenchido",
                  },
                ]}
              >
                <Select
                  showSearch filterOption optionFilterProp='children'
                  placeholder="Fundamentação Legal"
                  options={listFundamentacaoLegal}
                  onChange={(_, index) => {
                    handleFundamentacaoLegal(index);
                  }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={10}>
              <Checkbox onChange={onChangeInscricaoAutomatica}>Prevê Inscrição Automática</Checkbox>
            </Col>
          </Row>

        </Form>

        <Tabs
          defaultActiveKey="1"
          items={items}
        // onChange={onChange} 
        />


        <Form layout='vertical' style={{ padding: 24 }} onFinish={validarPlanoBeneficio} onFinishFailed={onFinishFailed} scrollToFirstError form={form} >

          <CadInfoBotoes
            resetForm={resetForm}
            detalhar={false}
            form={form}
            resetColor={resetColor}
            manter={manter}
            msgConfirmacao={`Novo Plano: ${sigla}`}
            rotaConsultar={"/" + import.meta.env.VITE_APP_BASE}
          />

        </Form >
      </Spin >

    </>
  );
};

export default Cadastrar;